import { commonActions } from '../app/actions';

export const setIsFetching = () => (dispatch) => {
  const { setValue } = commonActions('ui_is_fetching');
  dispatch(setValue());
};

export const setIsNotFetching = () => (dispatch) => {
  const { setValue } = commonActions('ui_is_not_fetching');
  dispatch(setValue());
};

export const setIsScrolling = () => (dispatch) => {
  const { setValue } = commonActions('ui_scrolling');
  dispatch(setValue());
};

export const setIsNotScrolling = () => (dispatch) => {
  const { setValue } = commonActions('ui_not_scrolling');
  dispatch(setValue());
};

export const setNotificationBarToOpen = () => (dispatch) => {
  const { setValue } = commonActions('notification_bar_open');
  dispatch(setValue());
};

export const setNotificationBarToClosed = () => (dispatch) => {
  const { setValue } = commonActions('notification_bar_closed');
  dispatch(setValue());
};

export const setHeatStreakPanelToOpen = () => (dispatch) => {
  const { setValue } = commonActions('heatstreak_panel_open');
  dispatch(setValue());
};

export const setHeatStreakPanelToClosed = () => (dispatch) => {
  const { setValue } = commonActions('heatstreak_panel_closed');
  dispatch(setValue());
};

export const setElementHeight = (height) => (dispatch) => {
  const { setValue } = commonActions('element_height');
  dispatch(setValue(height));
};

export const setElementFocused = (element) => (dispatch) => {
  const { setValue } = commonActions('element_in_view');
  dispatch(setValue(element));
};

export const incrementFetchErrorCount = (value) => (dispatch) => {
  const { setValue } = commonActions('INCREMENT_FETCH_ERROR_COUNT');
  dispatch(setValue({ fetchErrorCount: value }));
};

export const browserIsActive = (isActive) => (dispatch) => {
  const { setValue } = commonActions('APP_FOCUS_STATE');
  dispatch(setValue({ focusState: isActive }));
};

export const hasFetchError = () => (dispatch) => {
  dispatch({
    type: `FETCH_RESET`,
  });
};
